import { Salon, Stylist } from '../models'

// import { Subject } from 'rxjs';
import { ENV_CONFIG } from '../../bin/env.config'
import { ErrorHandlerService } from '../services/error-handler.service'
import { Auth } from '../services/login.service'
import { InAppPurchaseService } from '../services/inapp-purchase.service'
import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject } from 'rxjs'
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx'
import { StylistService } from '../services/stylist.service'
import { Utilities } from '../utilities/utilities'
import { switchMap } from 'rxjs/operators'
import { Platform } from '@ionic/angular'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'

// import * as Sentry from '@sentry/angular';
// const { logger } = Sentry;

declare var $crisp: any
declare var window: any
declare var posthog: any
declare var Beacon: any

// export interface User {
//   user: any;
//   salon: any;
//   token: string;
// }

// declare global {
//     interface Window { $crisp: any; }
// }

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private loggedIn: boolean
  private user: Stylist
  private salon: Salon
  private token: string

  private logInMonitor = new BehaviorSubject<boolean>(false)
  private logInMonitor$ = this.logInMonitor.asObservable()
  private logOutMonitor = new BehaviorSubject<boolean>(false)
  private logOutMonitor$ = this.logOutMonitor.asObservable()
  public sessionMonitor = new BehaviorSubject<Auth>(undefined)
  private sessionMonitor$ = this.sessionMonitor.asObservable()

  private isSideBarShowing = true

  private profileImageMonitor = new BehaviorSubject<any>(null)
  public profileImageMonitor$ = this.profileImageMonitor.asObservable()
  private helpScoutReadyHandlerRegistered = false

  constructor (
    private platform: Platform,
    // private stylistService: StylistService,
    // private salonService: SalonService,
    private oneSignal: OneSignal,
    protected errorHandlerService: ErrorHandlerService,
    private inAppPurchaseService: InAppPurchaseService
  ) {
    // // Subscribe to session changes to update HelpScout data
    // this.sessionMonitor$.subscribe(sessionData => {
    //   if (sessionData && sessionData.user && sessionData.salon) {
    //     console.log('change to the user session, update Help Scout visitor')
    //     this.initializeHelpScoutBeacon()
    //   }
    // })
    this.platform.ready().then(() => {
      // window.$crisp=[];

      if (this.platform.is('capacitor')) {
        //   // START IN APP PURCHASE
        // this.inAppPurchaseService.init();

        //   // START One SIGNAL
        // this.oneSignal.startInit(
        //   ENV_CONFIG.oneSignalAppID,
        //   ENV_CONFIG.fireBaseSenderID
        // );

        // this.oneSignal.inFocusDisplaying(
        //   this.oneSignal.OSInFocusDisplayOption.Notification
        // );

        // this.oneSignal.handleNotificationReceived().subscribe(() => {
        //   // do something when notification is received
        // });

        // this.oneSignal.handleNotificationOpened().subscribe(() => {
        //   // do something when a notification is opened
        // });

        // this.oneSignal.endInit();
        const addNotificationReceivedListener = async () => {
          await FirebaseMessaging.addListener(
            'notificationReceived',
            event => {}
          )
        }

        const addNotificationActionPerformedListener = async () => {
          await FirebaseMessaging.addListener(
            'notificationActionPerformed',
            event => {}
          )
        }
      }
    })

    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        const authStr = localStorage.getItem('auth')
        const userStr = localStorage.getItem('user')
        const salonStr = localStorage.getItem('salon')

        if (authStr && userStr && salonStr) {
          const auth: Auth = JSON.parse(authStr)
          auth.user = JSON.parse(userStr)
          auth.salon = JSON.parse(salonStr)
          this.login(auth)
        } else {
          this.clearSession()
        }
      } catch (err) {
        this.clearSession()
      }
    } else {
      this.clearSession()
    }

    // refresh user's session immediately
    // this.refreshSession().subscribe();

    // refresh user and salon object every 15 mins
    // const fifteenMins = 1000 * 60 * 15;
    // setInterval(() => {
    //   this.refreshSession().subscribe();
    // }, fifteenMins);
  }

  // public refreshSession () : Observable<boolean> {

  //   return new Observable <boolean> (observer => {
  //     observer.next(true);
  //     observer.complete();
  //   });

  // return new Observable <boolean> (observer => {
  //   if (this.isLoggedIn()) {
  //     this.stylistService.loadStylistInfo(this.user.id)
  //       .pipe(
  //         switchMap((stylist: Stylist) => {
  //           this.setUser(stylist);
  //           return this.salonService.load();
  //         })
  //       )
  //       .subscribe((salon: Salon) => {
  //         this.setSalon(salon);

  //         this.sessionMonitor.next({
  //           user: this.user,
  //           salon: this.salon,
  //           token: undefined
  //         });

  //         observer.next(true);
  //         observer.complete();
  //       }, (err) => {
  //         observer.error(this.errorHandlerService.handleError(err));
  //         observer.complete();
  //       });
  //   } else {
  //     // observer.error(new Error('User is not logged in'));
  //     // observer.complete();
  //   }
  // });
  // }

  public login (data: Auth) {
    this.clear()
    const apiToken = data.token
    const userData = data.user
    const salonData = data.salon
    const tokenObj = JSON.parse(apiToken)
    const userID = tokenObj.user_id
    // logger.info('login in user.service.ts', {
    //   userID: userID,
    //   apiToken: apiToken,
    //   userData: userData,
    //   salonData: salonData,
    // });

    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        localStorage.setItem('auth', JSON.stringify(data))
        localStorage.setItem('token', apiToken)
        localStorage.setItem('userID', userID)
        localStorage.setItem('stylistID', userID)
        localStorage.setItem('salonID', tokenObj.salonID)
        localStorage.setItem('administrator', tokenObj.administrator)
        // Save user and salon data separately for easier access
        localStorage.setItem('user', JSON.stringify(userData))
        localStorage.setItem('salon', JSON.stringify(salonData))
      } catch (err) {
        console.error('Error saving to localStorage:', err)
      }
    }
    const user: Stylist = Stylist.parseStylistData(userData)
    const salon: Salon = Salon.parse(salonData)
    this.setUser(user)
    this.setSalon(salon)
    this.token = apiToken
    this.loggedIn = true
    this.logInMonitor.next(true)

    const stylistFullName = user.getFirstName() + ' ' + user.getLastName()
    const stylistEmail = user.getEmail()
    const appVersion = salon.getAppVersion()
    const appBuildNum = ENV_CONFIG.appVersion
    const salonName = salon.getName()
    const hasCalendar = user.getCalendar() === 1 ? 'Yes' : 'No'
    const isAdmin = user.isAdministrator() ? 'Yes' : 'No'
    const canViewAllCalendars = user.getViewAllCalendars() === 1 ? 'Yes' : 'No'
    const canViewAllClients = user.getViewAllClients() === 1 ? 'Yes' : 'No'
    const hasSettingsControl = user.getSettingsControl() === 1 ? 'Yes' : 'No'
    const requiresApptConfirmation =
      user.getConfirmApptsManually() === 1 ? 'Yes' : 'No'
    const timeZone = salon.getTimeZone()
    const country = this.salon.getCountry()
      ? this.salon.getCountry().getCountryName()
      : ''
    const readOnly = this.salon.isReadOnly() ? 'Yes' : 'No'
    const salonWebsite = this.salon.getWebsite()
    const hasStripeAccount = this.salon.hasStripeAccount() ? 'Yes' : 'No'
    const stylistID = user.getID()

    // Link user to PostHog
    // posthog.identify(this.user.getID() + '', {
    //   name: stylistFullName,
    //   email: stylistEmail,
    //   app_version: appVersion,
    //   app_build_num: appBuildNum,
    //   company_name: salonName,
    //   has_calendar: hasCalendar,
    //   hide_default_launcher: false,
    //   is_admin: isAdmin,
    //   can_view_all_calendars: canViewAllCalendars,
    //   can_view_all_clients: canViewAllClients,
    //   has_settings_control: hasSettingsControl,
    //   requires_appt_confirmation: requiresApptConfirmation,
    //   time_zone: timeZone,
    //   country: country,
    //   read_only: readOnly,
    //   salon_website: salonWebsite,
    //   has_stripe_account: hasStripeAccount,
    // });

    // Link user to Segment
    window.analytics.identify(this.user.getID(), {
      name: stylistFullName,
      email: stylistEmail,
      app_version: appVersion,
      app_build_num: appBuildNum,
      company_name: salonName,
      has_calendar: user.getCalendar() === 1,
      is_admin: user.isAdministrator(),
      can_view_all_calendars: user.getViewAllCalendars() === 1,
      can_view_all_clients: user.getViewAllClients() === 1,
      has_settings_control: user.getSettingsControl() === 1,
      requires_appt_confirmation: user.getConfirmApptsManually() === 1,
      time_zone: timeZone,
      country: country,
      read_only: this.salon.isReadOnly(),
      salon_website: salonWebsite,
      has_stripe_account: this.salon.hasStripeAccount()
    })

    // Sentry.setUser({
    //   id: stylistID,
    //   email: stylistEmail,
    //   username: stylistFullName,
    // });

    // Initialize Help Scout Beacon with user context
    this.updateHelpScoutVisitor()

  }

  public isLoggedIn (): boolean {
    return this.loggedIn
  }


  public getLogInMonitor (): Observable<boolean> {
    return this.logInMonitor$
  }

  public getLogOutMonitor (): Observable<boolean> {
    return this.logOutMonitor$
  }

  public getSessionMonitor (): Observable<Auth> {
    return this.sessionMonitor$
  }

  public logout () {
    if ((Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) && this.isLoggedIn()) {
      this.oneSignal.deleteTag('stylistID')
    }

    this.clearSession()

    // clear posthog session
    // posthog.reset();

    // broadcast log out status
    this.logOutMonitor.next(true)
  }

  public clearSession () {
    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        localStorage.removeItem('auth')
        localStorage.removeItem('token')
        localStorage.removeItem('userID')
        localStorage.removeItem('stylistID')
        localStorage.removeItem('salonID')
        localStorage.removeItem('administrator')
        localStorage.removeItem('user')
        localStorage.removeItem('salon')
      } catch (err) {
        console.error('Error clearing localStorage:', err)
      }
    }
    this.clear()
  }

  public getUser (): Stylist {
    return this.user
  }

  public setUser (user: Stylist) {
    this.user = user
    if (Utilities.isHTM5LocalStorageSupported()) {
      localStorage.setItem('user', JSON.stringify(user.serialize()))
    }
  }
  public getSalon (): Salon {

    return this.salon
  }

  public setSalon (salon: Salon) {
    this.salon = salon
    if (Utilities.isHTM5LocalStorageSupported()) {
      localStorage.setItem('salon', JSON.stringify(this.salon.serialize()))
    }
  }

  public getToken (): string | undefined {
    // Return in-memory token if available
    if (this.token) {
      return this.token
    }
    
    // Fall back to localStorage if available
    if (Utilities.isHTM5LocalStorageSupported()) {
      try {
        const storedToken = localStorage.getItem('token')
        if (storedToken) {
          // Update in-memory token for future use
          this.token = storedToken
          return storedToken
        }
      } catch (err) {
        console.error('Error retrieving token from localStorage:', err)
      }
    }
    
    return undefined
  }


  public getSideBarVisibility (): boolean {
    return this.isSideBarShowing
  }

  public setSideBarVisiblity (visible: boolean) {
    this.isSideBarShowing = visible
  }


  public updateLastActivity () {
    if (this.isLoggedIn()) {
      localStorage.setItem('loginLastRecorded', Date.now().toString())
    }
  }


  public refreshUserData () {
    // logger.info('refreshUserData in user.service.ts');
    if (this.isLoggedIn()) {
      const authStr = localStorage.getItem('auth')
      const userStr = localStorage.getItem('user')
      const salonStr = localStorage.getItem('salon')
      // logger.info('refreshUserData in user.service.ts', {
      //   authStr: authStr,
      //   userStr: userStr,
      //   salonStr: salonStr,
      // });
      if (authStr && userStr && salonStr) {
        const auth: Auth = JSON.parse(authStr)
        auth.user = JSON.parse(userStr)
        auth.salon = JSON.parse(salonStr)
        this.login(auth)
      } else {
        // logger.error(
        //   'No auth, user, or salon data found in refreshUserData in user.service.ts'
        // );
      }
    }
  }

  updateProfileImg (newData: any) {
    this.profileImageMonitor.next(newData)
  }

  /**
   * Push stylist and salon data to Help Scout Beacon.
   * Includes default contact fields plus custom attributes for better context.
   */
  private updateHelpScoutVisitor () {
    if (
      !window ||
      !window.Beacon ||
      !this.isLoggedIn() ||
      !this.user ||
      !this.salon
    ) {
      return
    } else {
      console.log('Have the data we need to update Help Scout customer')
    }

    const user = this.user
    const salon = this.salon
    const stylistFullName = `${user.getFirstName()} ${user.getLastName()}`
    const stylistEmail = user.getEmail()
    const appVersion = salon.getAppVersion() || ''
    const appBuildNum = ENV_CONFIG.appVersion || ''
    const salonName = salon.getName()
    const hasCalendar = user.getCalendar() === 1 ? 'True' : 'False'
    const isAdmin = user.isAdministrator() ? 'True' : 'False'
    const canViewAllCalendars = user.getViewAllCalendars() === 1 ? 'True' : 'False'
    const canViewAllClients = user.getViewAllClients() === 1 ? 'True' : 'False'
    const hasSettingsControl = user.getSettingsControl() === 1 ? 'True' : 'False'
    const requiresApptConfirmation =
      user.getConfirmApptsManually() === 1 ? 'True' : 'False'
    const salonTimeZone = salon.getTimeZone() || ''
    const salonCountry = salon.getCountry() ? salon.getCountry().getCountryName()
      : ''
    const salonWebsite = salon.getWebsite() || ''
    const salonPhone = salon.getPhone() || ''
    const readOnly = salon.isReadOnly() ? 'True' : 'False'
    const hasStripeAccount = salon.hasStripeAccount() ? 'True' : 'False'
    const avatarUrl = user.getPhotoUrl()? `${ENV_CONFIG.STAFF_THUMBNAIL_PHOTO_ROOT}/${user.getPhotoUrl()}` : undefined
    const signature = user.helpscoutUserHash
    const bookingsCount = user.getBookingsCount() || 0
    const clientsCount = user.getClientsCount() || 0
    const servicesCount = user.getStylistServicesCount() || 0

    const identifyPayload: Record<string, any> = {
      name: stylistFullName,
      email: stylistEmail,
      company: salonName,
    }

    if (user.getTitle() && user.getTitle().length > 3) {
      identifyPayload.jobTitle = user.getTitle()
    }

    if (avatarUrl && avatarUrl.length > 3) {
      identifyPayload.avatar = avatarUrl
    }

    const customAttributes = {
      'stylist-id': user.getID(),
      'salon-id': salon.getId(),
      'app-version': appVersion,
      'app-build-number': appBuildNum,
      'has-calendar': hasCalendar,
      'is-administrator': isAdmin,
      'can-view-all-calendars': canViewAllCalendars,
      'can-view-all-clients': canViewAllClients,
      'has-settings-control': hasSettingsControl,
      'requires-appt-confirmation': requiresApptConfirmation,
      'salon-website': salonWebsite,
      'salon-timezone': salonTimeZone,
      'salon-country': salonCountry,
      'salon-phone': salonPhone,
      'read-only': readOnly,
      'has-stripe-account': hasStripeAccount,
      'stylist-pronouns': user.getPronoun() || '',
      'is-active': user.isActive() ? 'True' : 'False',
      'stats-link': salon.getId()? `https://salonmonster.com/internal/stats_detail.php?id=${salon.getId()}`
        : '',
      'salon-booking-link': salon.getSubDomain()  ? `${salon.getSubDomain()}.salonmonster.com`
        : '',
      'salon-creation-date': salon.getCreationDate() || '',
      'bookings-count': bookingsCount,
      'clients-count': clientsCount,
      'services-count': servicesCount,
    };

    if (!identifyPayload.email) {
      return
    }

    try {
      Beacon('identify', {
        ...identifyPayload,
        ...customAttributes,
        signature: user.helpscoutUserHash
      })

    } catch (err) {
      // Help Scout identify failed silently
    }
  }


  private clear () {
    this.loggedIn = false
    this.user = undefined
    this.salon = undefined
    this.token = undefined

    try {
      if (typeof Beacon !== 'undefined' || (window && window.Beacon)) {
        const beacon = typeof Beacon !== 'undefined' ? Beacon : window.Beacon
        beacon('logout', { endActiveChat: true })
      }
    } catch (err) {
      // Help Scout logout failed silently
    }
  }
}
